import React from 'react';
import {
  Button,
  designSystemToken,
  Label,
} from '@lightricks/react-design-system';
import useOpenPricing, {
  OPEN_PRICING_TYPE,
} from '@contentlab/hooks/use-open-pricing';
import useTrialUpgradeModal from '@contentlab/hooks/use-trial-upgrade-modal/useTrialUpgradeModal';
import {FreeTrialEndModalReason} from '@contentlab/stores/freeTrialEndModalStore';
import getActiveSubscription from '@contentlab/utils/getActiveSubscription';
import {
  isCancelledTrialPlan,
  isFreePlan,
  isTrialPlan,
} from '@contentlab/views/contentlab/pricing/utils';
import {CONTENT_STUDIO_PRICING_SOURCES} from '@/lib/analytics/analyticsConstants';
import translate from '@/utils/translate';
import useCurrentSubscriptionQuery from '@/hooks/content-studio/use-current-subscription-query';

interface UpgradeButtonProps {
  onClick?: (openType: string) => void;
}

function UpgradeButton(props: UpgradeButtonProps) {
  const {onClick} = props;
  const openPricing = useOpenPricing();
  const openTrialUpgradeModal = useTrialUpgradeModal();
  const {data, isLoading} = useCurrentSubscriptionQuery();

  const activeSubscription = getActiveSubscription(data?.subscriptions);

  const handleOpenPricing = () => {
    let openType = isFreePlan(activeSubscription)
      ? OPEN_PRICING_TYPE.REDIRECT
      : OPEN_PRICING_TYPE.MODAL;
    if (isCancelledTrialPlan(activeSubscription)) {
      openType = OPEN_PRICING_TYPE.REDIRECT;
    }
    openPricing(
      openType,
      CONTENT_STUDIO_PRICING_SOURCES.TOOL_BAR_UPGRADE_BUTTON
    );
    onClick?.(openType);
  };

  const handleUpgradeClick = () => {
    if (
      isTrialPlan(activeSubscription) &&
      activeSubscription?.isAutoRenewEnabled
    ) {
      openTrialUpgradeModal({
        source: 'upgrade_button',
        reason: FreeTrialEndModalReason.UPGRADE,
      });
    } else {
      handleOpenPricing();
    }
  };

  return (
    <Button
      appearance="brand"
      mode="filled"
      size="small"
      onClick={handleUpgradeClick}
      isLoading={isLoading}
      disabled={isLoading}
      sx={{
        'padding': '8px 16px !important',
        'margin': '0 !important',
        'minHeight': '32px !important',
        'height': '32px !important',
        'lineHeight': 1,
        '&.MuiButton-root': {
          margin: '0 !important',
          padding: '8px 16px !important',
        },
      }}
    >
      <Label size="md" color={designSystemToken('semantic.fg.white')}>
        {translate('Upgrade')}
      </Label>
    </Button>
  );
}

export default UpgradeButton;
